import { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useGetPurchaseTaxCountQuery, useGetPurchaseTaxListQuery } from "../../../../store/api/Purchasetax";
import ActionButtonDropdown from "../../../../Components/ActionButtonDropdown";
import SearchFilters from "../../../../Core/SearchFilters/SearchFilters";
import Pagination from "../../../../Core/Pagination/Pagination";
import ListLayout from "../../../../Core/Layout/ListLayout";
import PopBox from "../../../../Components/Popup/Popup";
import Table from "../../../../Core/Table/Table";
import Tabs from "../../../../Components/Tabs";
import ExportCSV from '../../../../Core/Export/ExportCSV'
import ListFilters from "../../../../Core/ListFilters/ListFilters";
import ConfigureColumnsNew from "../../../../Core/ConfigureColumnsNew/ConfigureColumnsNew";
import { useDeleteDocMutation } from "../../../../store/api/globalapi";
import DelConfirmPopup from "../../../../Components/Popup/DelConfirmPopup ";
import useScreenHeight from "../../../../utils/useScreenHeight";
const MainContent = () => {
    const navigate = useNavigate();
    const { screenHeight, screenScaling , pageSize} = useScreenHeight();
    const [totalData, setTotalData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [filters, setFilters] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [isPopBoxOpen, setIsPopBoxOpen] = useState(false);
    const [showExportPopup, setShowExportPopup] = useState(false);
    const [showColumnConfig, setShowColumnConfig] = useState(false);
    const [showFilters, setShowFilters] = useState(false);
    //states used for deleting the record
    const [deleteDoc] = useDeleteDocMutation();
    const [delPopupVisible, setDelPopupVisible] = useState(false);
    const [delSelectedId, setDelSelectedId] = useState(null);
    const [delmessage, setDelmessage] = useState();
    const [alreadySubmitData, setAlreadySubmitData] = useState(false);
    const [delDone, setDelDone] = useState(false);
    
    // 🔹 Extract SI No. filter (frontend-only)
    const siNoFilter = filters.siNo?.trim();
    const isSiNoActive = siNoFilter !== undefined && siNoFilter !== "";

    // 🔹 Determine target page for SI No. search
    const targetPage = isSiNoActive
        ? Math.ceil(parseInt(siNoFilter, 10) / pageSize)
        : currentPage;

    // 🔹 Build filter array for API
    const buildFilterArray = (filtersObj) => {
        return Object.entries(filtersObj)
            .filter(([key, value]) => key !== "siNo" && value?.trim() !== "")
            .map(([key, value]) => {
                if (key === "creation") {
                    // Backend expects partial date match
                    return ["Purchase Taxes and Charges Template", key, "like", `${value}%`];
                }
                return ["Purchase Taxes and Charges Template", key, "like", `%${value}%`];
            });
    };


    const { data: purchaseData, isLoading, refetch:refetchPurchaseTaxList } = useGetPurchaseTaxListQuery({
        start: (targetPage - 1) * pageSize,
        limit: pageSize,
        filters: buildFilterArray(filters),
    });

    const { data: totalCount, refetch: refetchPurchaseTaxCount } = useGetPurchaseTaxCountQuery();


    useEffect(() => {
        if (totalCount) {
            setTotalRecords(totalCount.message);
        }
    }, [totalCount]);

    useEffect(() => {
        if (purchaseData) {
            const rawData = purchaseData.data || [];
            const numberedData = rawData.map((item, idx) => ({
                ...item,
                siNo: idx + 1 + pageSize * (targetPage - 1),
            }));
            const finalData = isSiNoActive
                ? numberedData.filter(item => item.siNo === parseInt(siNoFilter, 10))
                : numberedData;

            setTotalData(finalData);
            if (isSiNoActive && currentPage !== targetPage) {
                setCurrentPage(targetPage);
            }
        }
    }, [purchaseData, isSiNoActive, siNoFilter, targetPage, currentPage, pageSize]);
    useEffect(() => {
        if (pageSize > 0)
            refetchPurchaseTaxList();
		}, [
			filters,
			currentPage,
			refetchPurchaseTaxList,
			pageSize,
			screenHeight,
			screenScaling,
		]);

    const filtersConfig = [
        { name: 'siNo', label: 'S. No.', width: '10%', type: 'number' },
        { name: 'title', label: 'Title', width: '26%', type: 'text' },
        { name: 'company', label: 'Company', width: '26%', type: 'text' },
        { name: 'creation', label: 'Date', type: 'date', width: '26%' },
    ];
    const handleFilterChange = (newFilters) => {
        setFilters(newFilters);
        setCurrentPage(1);
    };

    const handleView = (id) => {
        navigate(`/master/tax/purchase-view-tax`, { state: { purchaseId: id } });
    };

    const handleEdit = (id) => {
        navigate(`/master/tax/purchase-edit-tax`, { state: { purchaseId: id } });
    };


    const handleDelete = (id) => {
        setDelSelectedId(id);
        setDelPopupVisible(true);
        setAlreadySubmitData(false);
        setDelmessage("Are you sure you want to Delete this Purchase Taxes and Charges Template?");
    };

    const delHandleCancel = () => {
        setDelPopupVisible(false);
        setDelSelectedId(null);
    };

    const delHandleConfirm = async () => {
        try {
            await deleteDoc({
                doctype: "Purchase Taxes and Charges Template",
                name: delSelectedId,
            }).unwrap();
            setDelmessage(`Purchase Taxes and Charges Template ${delSelectedId} deleted successfully!`);
            setDelDone(true);
            setTimeout(() => {
                setDelPopupVisible(false);
                setDelSelectedId(null);
                setDelDone(false);
                refetchPurchaseTaxCount();
                refetchPurchaseTaxList();
            }, 1000);
        } catch (err) {
            console.error("Deletion Failed:", err);

            let errorMessage = "Failed to delete the Purchase Taxes and Charges Template!";

            //If the server is sending the error message , we will extract it.
            if (err?.data?._server_messages) {
                try {
                    const messageArr = JSON.parse(err.data._server_messages);
                    if (messageArr && messageArr.length > 0) {
                        //parse inner json object
                        const messageObj = JSON.parse(messageArr[0]);
                        if (messageObj?.message) {
                            //extract the exact message we want
                            const fullMessage = messageObj.message;
                            errorMessage = fullMessage.split("You must")[0].trim();
                            //remove html in the message
                            errorMessage = errorMessage.replace(/<[^>]+>/g, "");
                        }
                    }
                } catch (parseError) {
                    console.error("Error parsing server messages:", parseError);
                }
            }
            setDelPopupVisible(true);
            setDelmessage(errorMessage);
            setAlreadySubmitData(true);
        } finally {
            // setTimeout(() => {
            //     setDelPopupVisible(false);
            //     setDelSelectedId(null);
            // }, 2000);
        }
    };

    const [columnsConfig, setColumnsConfig] = useState(() => [

        {
            header: "S. No.",
            name: "S. No.",
            accessor: "siNo",
            visible: true,
            sortable: true,
            width: '20%',
            cellRenderer: (row) => row.siNo,
        },
        {
            header: "Title",
            name: 'title',
            accessor: "title",
            visible: true,
            sortable: true,
            width: '20%',
        },
        {
            header: "Company",
            name: 'Company',
            accessor: "company",
            sortable: true,
            visible: true,
            width: '20%',
        },
        {
            header: "Date",
            name: 'Date',
            accessor: "creation",
            sortable: true,
            visible: false,
            width: '20%',
            cellRenderer: (row) => row.creation?.split(" ")[0],
        },
        {
            header: "Status",
            accessor: "disabled",
            width: '10.7%',
            name: 'Status',
            visible: true,
            sortable: false,
            cellRenderer: (row) => {
                const statusText = row.disabled === 0 ? "Enabled" : "Disabled";
                const color = row.disabled === 0 ? "#16A34A" : "#EF4444";
                return <span style={{ color }}>{statusText}</span>;
            }
        },
        {
            header: "Action",
            name: 'Acion',
            accessor: "action",
            visible: true,
            sortable:false,
            cellRenderer: (row) => (
                <ActionButtonDropdown
                    id={row.name}
                    onView={() => handleView(row.name)}
                    onEdit={() => handleEdit(row.name)}
                    onDelete={() => handleDelete(row.name)}
                />
            ),
        },
    ], [currentPage, pageSize]);

    // Handle column configuration changes
    const handleSaveColumns = (selectedKeys, allFields) => {
        const updatedColumns = columnsConfig.map(column => {
            return {
                ...column,
                visible: selectedKeys.includes(column.accessor)
            };
        });
        setColumnsConfig(updatedColumns);
    };

    const visibleColumns = useMemo(() =>
        columnsConfig.filter(col => col.visible === true),
        [columnsConfig]
    );

    const defaultSelectedColumns = useMemo(() =>
        columnsConfig
            .filter(col => col.visible === true)
            .map(col => ({
                fieldname: col.accessor,
                label: col.name
            }))
            .filter(col => col.fieldname),
        [columnsConfig]
    );
    const activeFilterCount = useMemo(() => {
        return Object.values(filters).filter(val => val !== null && val !== undefined && val !== '').length;
    }, [filters]);

    const actionButtons = [
        {
            className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "IoFilterSharp",
            iconSize: 12,
            children: activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter",
            onClick: () => {
                setShowFilters(prev => !prev);
                setShowColumnConfig(false);
            }
        },
        {
            className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "MdOutlineRemoveRedEye",
            iconSize: 12,
            children: "Show more",
            onClick: () => {
                setShowColumnConfig(prev => !prev);
                setShowFilters(false);
            }
        },
        {
            className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "RiFileExcel2Fill",
            iconSize: 12,
            children: "Export Excel",
            onClick: () => setShowExportPopup(true),

        },
        {
            className: "custom-btn-00989 d-flex",
            to: "/master/tax/purchase-create-tax",
            iconName: "FiPlus",
            style: { gap: '2px', height: '28px' },
            children: "Add Taxes and Charges Template"
        }
    ];

    const accessors = columnsConfig
			.filter(
				(column) => column.accessor !== "siNo" && column.accessor !== "action"
			)
			.map((column) => column.accessor);
    return (
        <div className="container-fluid d-flex flex-column" style={{ flexGrow: '1' }}>
            <Tabs />
            <ListLayout
                breadcrumbItems={[
                    { label: "Purchase Taxes and Charges Template" },
                    { label: "Purchase Taxes and Charges Template List", style: { color: '#270B79' } }
                ]}
                actionButtons={actionButtons}
            >
                {
                    showFilters && <ListFilters
                        filtersConfig={filtersConfig}
                        onFilterChange={handleFilterChange}
                        currentFilters={filters}
                        setShowFilters={setShowFilters}
                    />
                }
                {showColumnConfig &&
                    <ConfigureColumnsNew
                        show={showColumnConfig}
                        onClose={() => setShowColumnConfig(false)}
                        onSave={handleSaveColumns}
                        docType="Purchase Taxes and Charges Template"
                        defaultSelected={defaultSelectedColumns}
                        fieldsData={columnsConfig.map(col => ({
                            fieldname: col.accessor,
                            label: col.name
                        }))}
                        disabledFields={["siNo", "title", "action", "company"]}
                    />}
                <Table
                    columns={visibleColumns}
                    data={totalData}
                    loading={isLoading}
                />
                <Pagination
                    setCurrentPage={setCurrentPage}
                    pageSize={pageSize}
                    totalRecords={totalRecords}
                    currentPage={currentPage}
                    className="mt-2 pb-3"
                />
                {delPopupVisible && (
					<DelConfirmPopup
						alredysubmitdata={alreadySubmitData}
						delSelectedId={delSelectedId}
						visible={delPopupVisible}
						message={delmessage}
						onConfirm={delHandleConfirm}
						onCancel={delHandleCancel}
						delDone={delDone}
					/>
        )}
        
                {showExportPopup && (
                    <ExportCSV
                        doctype="Purchase Taxes and Charges Template"
                        fieldsData={accessors}
                        onClose={() => setShowExportPopup(false)}
                    />
                )}
                <PopBox
                    isOpen={isPopBoxOpen}
                    onClose={() => setIsPopBoxOpen(false)}
                    title="Select Company"
                >
                    <div className="selectbox">
                        <p>Settings content goes here</p>
                    </div>
                </PopBox>
            </ListLayout>

        </div>
    );
};

export default MainContent;
